import type { DocumentRepository } from "../repositories/document-repository"

export const makeReparseDocuments = (repo: DocumentRepository) =>
  (docIds: string[]) =>
    repo.reparse(docIds)
